import { render, staticRenderFns } from "./trialBalanceOptionBtn.vue?vue&type=template&id=22015348"
import script from "./trialBalanceOptionBtn.vue?vue&type=script&lang=js"
export * from "./trialBalanceOptionBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports